export const enum UserForgotPasswordStatechartEvent {
  /**
   * Reset statechart to idle state (after closing and opening popup)
   */
  reset = 'reset',

  /**
   * User wants to reset password
   */
  wantToResetPassword = 'wantToResetPassword',

  /**
   * User input is valid
   */
  inputIsValid = 'inputIsValid',

  /**
   * Input is not valid
   */
  inputIsNotValid = 'inputIsNotValid',

  /**
   * Captcha value changed
   */
  captchaValueChanged = 'captchaValueChanged',

  /**
   * User reset password failed
   */
  resetPasswordFailed = 'resetPasswordFailed',

  /**
   * Password reset was successful
   */
  resetPasswordSucceeded = 'resetPasswordSucceeded',
}
